import { FC, useState } from 'react';
import './SidebarSectionsArticlesFilter.scss';
import SidebarFilter from '../../../../components/SidebarFilter/SidebarFilter';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { Col, FormGroup, Row } from 'react-bootstrap';
import InputDateRange from '../../../../components/InputDateRange/InputDateRange';
import { useSections } from '../../../../providers/Articles/Sections/SectionsProvider';

interface SidebarSectionsArticlesFilterProps { }

// @ts-ignore
export const defaultValues = {
  name: '',
  startDate: '',
  endDate: '',
} as any;

const SidebarSectionsArticlesFilter: FC<SidebarSectionsArticlesFilterProps> = () => {
  const [startDate, setStartDate] = useState<any>(moment(new Date()).format('YYYY-MM-01 HH:mm:ss'));
  const [endDate, setEndDate] = useState<any>(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));

  const { handleSubmit, register, setValue } = useForm<any>({ defaultValues });

  const { setParams } = useSections();

  const onSubmit = async (data: any) => {
    const { page: _page, perPage: _perPage, withPaginate: _withPaginate, ...rest } = data;

    const filter = {
      ...rest,
      startDate: data?.startDate ? moment(data.startDate).format('YYYY-MM-DD') : '',
      endDate: data?.endDate ? moment(data.endDate).format('YYYY-MM-DD') : '',
    };

    setParams((prev: any) => ({
      ...prev,
      filter: { ...(prev?.filter ?? {}), ...filter },
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  }

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div className="SidebarSectionsArticlesFilter" data-testid="SidebarSectionsArticlesFilter">
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME</label>
              <input
                className="form-control"
                {...register('name')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <InputDateRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setValue={setValue}
              startLabelText={'DATA INICIAL'}
              endLabelText={'DATA FINAL'}
            />
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
}

export default SidebarSectionsArticlesFilter;
